import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChevronDown,
  faDownload,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";

export default function ExportDropdown({
  disabled = false,
  buttonLabel = "Export",
  // Old API (desktop)
  actions,
  // New API (MobileLeaderboardView)
  canExportContactInfo,
  isExportingContactInfo = false,
  onExport,
  onExportContactInfo,
}) {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!containerRef.current?.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // Resolve which API is being used
  const resolvedActions = actions ?? [
    ...(onExport ? [{ label: buttonLabel, onClick: onExport }] : []),
    ...(canExportContactInfo && onExportContactInfo
      ? [{ label: "Export with Contact Info", onClick: onExportContactInfo }]
      : []),
  ];

  const handleActionClick = (action) => {
    action?.onClick?.();
    setIsOpen(false);
  };

  const buttonClasses = `px-4 py-2 rounded-lg text-sm flex items-center gap-2 ${
    disabled
      ? "bg-gray-100 text-gray-400 cursor-not-allowed"
      : "bg-gray-200 cursor-pointer"
  }`;

  // Single action: render a plain button without a dropdown
  if (resolvedActions.length <= 1) {
    const singleAction = resolvedActions[0];
    return (
      <button
        className={buttonClasses}
        onClick={() => !disabled && singleAction?.onClick?.()}
        disabled={disabled}
      >
        <FontAwesomeIcon icon={faDownload} />
        {buttonLabel}
      </button>
    );
  }

  return (
    <div className="relative" ref={containerRef}>
      <button
        className={buttonClasses}
        onClick={() => {
          if (disabled) return;
          setIsOpen((prev) => !prev);
        }}
        disabled={disabled}
      >
        <FontAwesomeIcon icon={faDownload} />
        {buttonLabel}
        <FontAwesomeIcon icon={faChevronDown} className="text-sm" />
      </button>

      {isOpen && (
        <div className="absolute z-20 mt-1 min-w-56 rounded-md border bg-white shadow-lg text-left">
          {resolvedActions.map((action) => (
            <button
              key={action.label}
              className="w-full px-4 py-3 text-sm hover:bg-gray-100 text-left flex items-center gap-2"
              onClick={() => handleActionClick(action)}
              disabled={
                action.label.includes("Contact") && isExportingContactInfo
              }
            >
              <FontAwesomeIcon
                icon={
                  action.label.includes("Contact") && isExportingContactInfo
                    ? faSpinner
                    : faDownload
                }
                className={
                  action.label.includes("Contact") && isExportingContactInfo
                    ? "animate-spin"
                    : ""
                }
              />
              {action.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
